// extracted by mini-css-extract-plugin
export default {"form":"xGVZ5","actions":"qUjVQ","action":"NBE3f","section":"u_nTG","sectionTitle":"JUrXJ"};